import { render, staticRenderFns } from "./SalesOrderStatusCustomerId.vue?vue&type=template&id=eb72721e&"
import script from "./SalesOrderStatusCustomerId.vue?vue&type=script&lang=js&"
export * from "./SalesOrderStatusCustomerId.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderStatusCustomerId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports